module.exports = __webpack_public_path__ + "static/media/try-andie-arrow-up-es.b80af821.svg";